export default __webpack_public_path__ + "static/media/red_arrow.d26d51d7.svg";